import React from 'react';
import HeaderSection from '../components/Headersection';




function Home() {
    console.log("home");
  return (
    <div>
      <HeaderSection />
      
    </div>
  );
}

export default Home;